var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.avatarUrl)?_c('img',{staticClass:"user-image",style:({
    width: (_vm.size + "px"),
    height: (_vm.size + "px"),
  }),attrs:{"src":_vm.avatarUrl,"alt":_vm.user}}):_c('div',{staticClass:"user-image",style:({
    width: (_vm.size + "px"),
    height: (_vm.size + "px"),
    fontSize: (_vm.size + "px;"),
  })},[_vm._v(" "+_vm._s(_vm.initial)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }